import { mqMin, space, tokPx } from '@sunwebgroup/ui-components'
import { Skeleton } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'
import {
  AccoCardContainer,
  CardFooter,
  CardHeader,
  CardMain,
} from './AccoCard'

const ImageContainer = styled(Skeleton)`
  aspect-ratio: 1/1;
  width: 115px;
  flex-shrink: 0;

  @media ${mqMin('primitives_breakpoint_l_min')} {
    width: 100%;
    aspect-ratio: 3/2;
  }
`

const SmallTextSkeleton = styled(Skeleton)<{ $width?: string }>`
  width: ${({ $width }) => $width || '100px'};
  height: ${space('primitives_space_16')};
`

const LargeTextSkeleton = styled(Skeleton)`
  width: 75%;
  height: ${space('primitives_space_24')};

  &:last-of-type {
    width: 90%;
  }
`

const CardFooterSkeleton = styled(Skeleton)`
  height: ${space('primitives_space_44')};
  width: 108px;
  border-radius: ${tokPx('primitives_corner_radius_full')};
`

export function MapAccoCardLoading() {
  return (
    <AccoCardContainer>
      <ImageContainer />
      <CardMain>
        <CardHeader>
          <SmallTextSkeleton />
          <LargeTextSkeleton />
          <LargeTextSkeleton />
          <SmallTextSkeleton $width="225px" />
        </CardHeader>
        <CardFooter>
          <CardFooterSkeleton />
        </CardFooter>
      </CardMain>
    </AccoCardContainer>
  )
}
